// components/AnalysisCard.jsx
import React from "react";

const severityColors = {
  none: "bg-[#E6FFEB] border border-[#A3E6AF] text-[#22B459]",
  normal: "bg-[#E6FFEB] border border-[#A3E6AF] text-[#22B459]",
  mild: "bg-[#FEF9C3] border border-[#E8E3AD] text-[rgb(202_138_4)]",
  moderate:
    "bg-[rgb(255_247_237)] border border-[#fbead5] text-[rgb(234_88_12)]",
  frm: "bg-[#E6FFEB] border border-[#A3E6AF] text-[#22B459]",
  good: "bg-[#FEF9C3] border border-[#E8E3AD] text-[#854D0E]",
};

const AnalysisCard = ({
  icon,
  title,
  severity,
  confidence,
  description,
  areas,
}) => {
  return (
    <div className="bg-white rounded-[20px] border border-black/10 p-4 mb-3">
      <div className="flex justify-between items-start mb-2">
        <div className="flex items-center gap-3">
          <img src={icon} alt={title} className="w-5 h-5" />
          <h3 className="text-sm font-medium text-primary">{title}</h3>
        </div>
        <div className="flex gap-2">
          <span
            className={`text-xs font-semibold px-2 py-1 rounded-full capitalize ${
              severityColors[severity] || "bg-gray-100 text-gray-600"
            }`}
          >
            {severity}
          </span>
          <span className="text-xs font-normal text-primary bg-[#fff] border border-[#DCE4DE] px-3 py-1 rounded-full">
            {confidence}
          </span>
        </div>
      </div>
      <p className="text-xs text-primary/80 mt-3">{description}</p>
      {areas && areas.length > 0 && (
        <div className="text-xs text-gray-600 mt-2">
          <span className="font-semibold mr-1">Areas:</span>
          {areas.map((area, idx) => (
            <span
              key={idx}
              className="inline-block px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs mr-1 mb-1"
            >
              {area}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalysisCard;
